const Footer = () => {
  const currentYear = new Date().getFullYear();

  return (
    <footer className="section-alt border-t border-[var(--color-border-light)]">
      <div className="container mx-auto pt-12 sm:pt-16 md:pt-20">
        <div className="grid md:grid-cols-3 gap-8 sm:gap-10 md:gap-12 mb-8 sm:mb-10 md:mb-12">
          {/* Contact Info */}
          <div>
            <h3 className="text-heading mb-4 sm:mb-6 text-sm sm:text-base">Kontakt</h3>
            <div className="space-y-2 text-sm sm:text-base text-[var(--color-text-secondary)]">
              <p>
                <strong>Hårgalleriet Selma P</strong><br />
                Din frisörsalong i centrala Limhamn
              </p>
              <p className="mt-3 sm:mt-4">
                Telefon:{' '}
                <a href="tel:0739869448" className="hover:text-[var(--color-accent-500)] transition-colors">
                  0739-869448
                </a>
              </p>
            </div>
          </div>

          {/* Location */}
          <div>
            <h3 className="text-heading mb-4 sm:mb-6 text-sm sm:text-base">Plats</h3>
            <address className="not-italic text-sm sm:text-base text-[var(--color-text-secondary)]">
              Järnvägsgatan 28<br />
              21614 Limhamn
            </address>
            <a
              href="https://maps.google.com/?q=Järnvägsgatan+28,+21614+Limhamn"
              target="_blank"
              rel="noopener noreferrer"
              className="text-sm sm:text-base text-[var(--color-accent-500)] hover:text-[var(--color-accent-600)] transition-colors inline-block mt-2"
            >
              Vägbeskrivning →
            </a>
          </div>

          {/* Social */}
          <div>
            <h3 className="text-heading mb-4 sm:mb-6 text-sm sm:text-base">Följ oss</h3>
            <p className="text-sm sm:text-base text-[var(--color-text-secondary)] mb-3 sm:mb-4">
              Följ oss på Instagram för inspiration, före- och efterbilder samt erbjudanden.
            </p>
            <div className="flex gap-4">
              <a
                href="https://www.instagram.com/hargalleriet_selma_p"
                target="_blank"
                rel="noopener noreferrer"
                className="w-10 h-10 flex items-center justify-center border border-[var(--color-border-medium)] rounded-full hover:bg-[var(--color-accent-500)] hover:border-[var(--color-accent-500)] hover:text-white transition-colors"
              >
                <svg className="w-5 h-5" fill="currentColor" viewBox="0 0 24 24">
                  <path d="M12 2.163c3.204 0 3.584.012 4.85.07 3.252.148 4.771 1.691 4.919 4.919.058 1.265.069 1.645.069 4.849 0 3.205-.012 3.584-.069 4.849-.149 3.225-1.664 4.771-4.919 4.919-1.266.058-1.644.07-4.85.07-3.204 0-3.584-.012-4.849-.07-3.26-.149-4.771-1.699-4.919-4.92-.058-1.265-.07-1.644-.07-4.849 0-3.204.013-3.583.07-4.849.149-3.227 1.664-4.771 4.919-4.919 1.266-.057 1.645-.069 4.849-.069zm0-2.163c-3.259 0-3.667.014-4.947.072-4.358.2-6.78 2.618-6.98 6.98-.059 1.281-.073 1.689-.073 4.948 0 3.259.014 3.668.072 4.948.2 4.358 2.618 6.78 6.98 6.98 1.281.058 1.689.072 4.948.072 3.259 0 3.668-.014 4.948-.072 4.354-.2 6.782-2.618 6.979-6.98.059-1.28.073-1.689.073-4.948 0-3.259-.014-3.667-.072-4.947-.196-4.354-2.617-6.78-6.979-6.98-1.281-.059-1.69-.073-4.949-.073zm0 5.838c-3.403 0-6.162 2.759-6.162 6.162s2.759 6.163 6.162 6.163 6.162-2.759 6.162-6.163c0-3.403-2.759-6.162-6.162-6.162zm0 10.162c-2.209 0-4-1.79-4-4 0-2.209 1.791-4 4-4s4 1.791 4 4c0 2.21-1.791 4-4 4zm6.406-11.845c-.796 0-1.441.645-1.441 1.44s.645 1.44 1.441 1.44c.795 0 1.439-.645 1.439-1.44s-.644-1.44-1.439-1.44z"/>
                </svg>
              </a>
            </div>
          </div>
        </div>

        {/* Bottom Bar */}
        <div className="pt-6 sm:pt-8 pb-4 sm:pb-0 border-t border-[var(--color-border-light)] text-center text-xs sm:text-sm text-[var(--color-text-secondary)]">
          <p>© {currentYear} Hårgalleriet Selma P. Alla rättigheter reserverade.</p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
